// extracted by mini-css-extract-plugin
export default {"root":"classes_root__z1xEp","duration-container":"classes_duration-container__ixR19","amount-container":"classes_amount-container__lJ7A6","label":"classes_label__kfz0R"};